module.exports = __webpack_public_path__ + "static/media/user.c8dd4754.JPG";